import React from 'react';
import { Results as RiskToleranceScore } from '../../../../../../RiskToleranceWorkflow/steps/Results/Results';
import { useCompleteWorkflowMutation } from '../../../../../../RiskToleranceWorkflow/api/useCompleteWorkflowMutation';
import { useRouteParams } from '../../../../../../RiskToleranceWorkflow/hooks/useRouteParams';
import { useWorkflowCompleteNavigateAway } from '../../../../../../RiskToleranceWorkflow/hooks/useWorkflowCompleteNavigateAway';
import { FullPageLoading } from '../../../../../../CommonComponents/OPL/FullpageLoading/FullPageLoading';
import { PortfolioDTO } from '../../../../../../RiskToleranceWorkflow/api/useSubmitAnswersMutation';

interface Props {
  onRestart(): void;
  portfolio: PortfolioDTO;
}

export const Results: React.FC<Props> = ({ onRestart, portfolio }) => {
  const { clientId } = useRouteParams();

  const {
    mutateAsync: completeWorkflowMutation,
    isLoading: isCompletingWorkflowMutation,
  } = useCompleteWorkflowMutation();

  const { navigateAway, isLoading: isNavigatingAway } = useWorkflowCompleteNavigateAway();

  if (isCompletingWorkflowMutation || isNavigatingAway) {
    return <FullPageLoading text="Loading" />;
  }

  return (
    <RiskToleranceScore
      portfolio={portfolio}
      onRestart={onRestart}
      onFinish={async () => {
        try {
          await completeWorkflowMutation({ clientId });
          await navigateAway();
        } catch (err) {
          console.error(err);
        }
      }}
    />
  );
};
